<div class="block">
  <div class="title">
    <ng-content select="[block-title]"></ng-content>
  </div>
  <div>
    <ng-content select="[block-content]"></ng-content>
  </div>
</div>
